import { useEffect } from 'react';
import { EditableDataGrid } from '../../../builderPackage/components/editableDataGrid/editableDataGrid';
import { useAppSelector } from '../../../store/hooks';
import { getByStockTransferRequisition } from '../apiCall';
import { StockTransferRequisitionAPIKeys } from '../entity';
var ViewAddedParts = function (props) {
    var _crud$StockTransferRe;
    var value = props.value;
    var crud = useAppSelector(function (state) { return state.crud; });
    useEffect(function () {
        if (value !== null && value !== void 0 && value.id) {
            var request = {
                StockTransferRequisitionId: value === null || value === void 0 ? void 0 : value.id
            };
            getByStockTransferRequisition({
                request: request
            });
        }
    }, []);
    var columns = [{
            field: 'ProductName',
            headerName: 'Part name & code',
            flex: 1,
            headerAlign: 'center',
            minWidth: 150
        }, {
            field: 'UnitOfMeasurementName',
            headerName: 'UOM',
            flex: 1,
            headerAlign: 'center'
        }, {
            field: 'AvailableQuantity',
            headerName: 'Available Qty',
            flex: 1,
            headerAlign: 'center'
        }, {
            field: 'RequestedQuantity',
            headerName: 'Req. transfer qty',
            flex: 1,
            headerAlign: 'center'
        }, {
            field: 'Remarks',
            headerName: 'Remarks',
            flex: 1,
            headerAlign: 'center'
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(EditableDataGrid, {
        columns: columns,
        dataGridHeader: "Part details",
        isCollapsible: true,
        disableAddRow: true,
        dataGridProps: {
            disableRowSelectionOnClick: true,
            hideFooter: true,
            disableColumnSorting: true
        },
        rows: ((_crud$StockTransferRe = crud[StockTransferRequisitionAPIKeys.get]) === null || _crud$StockTransferRe === void 0 ? void 0 : _crud$StockTransferRe.data) || []
    }));
};
export default ViewAddedParts;
